/* ao-ts-reviews — echte Trusted-Shops-Bewertungen in den Startseiten-Block (30.08.2026)
 *
 * WARUM ÜBERHAUPT EIGENE KARTEN
 * Das eTrusted-Stimmen-Widget kann nur EINE Bewertung zeigen: In seiner Konfiguration
 * steht ein festes `reviewId`-Feld, es ist kein Slider. Jonas wollte mehrere Stimmen.
 * Trusted Shops veröffentlicht die Bewertungen aber selbst über eine offene Schnittstelle
 * ohne Schlüssel — von dort kommen sie hier.
 *
 * ZWEI QUELLEN, ZWEI ZWECKE
 * 1. Noten-Feed (`integrations.etrusted.com/feeds/grades/…`) — Gesamtzahl und die
 *    Verteilung auf 1–5 Sterne. Daraus die zwei Kennzahlen links.
 * 2. Bewertungs-API (`api.trustedshops.com/rest/public/v2/shops/<tsId>/reviews.xml`) —
 *    die zehn neuesten Bewertungen. Öffentlich, ohne Authentifizierung.
 *
 * WARUM KEINE NAMEN
 * Auf seiner eigenen Profilseite zeigt Trusted Shops abgekürzte Namen („Monika P.").
 * Die stammen aus einer internen Schnittstelle der Profilseite, nicht aus der offenen
 * API — dort gibt es überhaupt kein Verbraucherfeld (am 30.08. gegen die XML- und die
 * JSON-Fassung geprüft: Elemente sind UID, comment, mark, criteria, Datumsfelder, sonst
 * nichts). Statt eines erfundenen Namens steht deshalb Datum, Prüfvermerk und ein
 * Direktlink auf genau diese Bewertung bei Trusted Shops.
 *
 * WAS HIER NICHT PASSIERT
 * Es wird nicht nach Note ausgewählt. Die Liste ist die Reihenfolge, die Trusted Shops
 * liefert (neueste zuerst); übersprungen werden nur Bewertungen ohne Kommentartext —
 * eine leere Karte hat keinen Inhalt. Genau so steht es auch im Echtheitshinweis unter
 * dem Block (§ 5b Abs. 3 UWG). Wer hier eine Sortierung nach Sternen einbaut, macht aus
 * einer Wiedergabe eine Auswahl und damit den Hinweis falsch.
 *
 * AUSFALLVERHALTEN
 * Kommt die Bewertungsliste nicht, klappt die Karte auf eine Spalte zusammen
 * (`ao-tsrev__grid--solo`) statt eine leere Fläche zu zeigen. Kommen die Kennzahlen
 * nicht, bleiben die Zeilen leer und werden ausgeblendet. Ausfallmodus ist immer
 * „weniger", nie „falsch".
 */
(function () {
  'use strict';

  var GRADES = 'https://integrations.etrusted.com/feeds/grades/v1/channels/';
  var REVIEWS = 'https://api.trustedshops.com/rest/public/v2/shops/';

  function zahl(n) {
    return n.toLocaleString('de-DE');
  }

  function holen(url) {
    return fetch(url, { credentials: 'omit' }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    });
  }

  /* 🪤 XML STATT JSON — 02.09.2026
     Die JSON-Fassung der Bewertungs-Schnittstelle (`.../reviews.json`) antwortet seit
     mindestens dem 02.09.2026 mit HTTP 503, und zwar HOST-WEIT: auch fremde Shop-IDs
     bekommen 503, es liegt also nicht an unserem Konto. Die XML-Fassung derselben
     Ressource liefert unveraendert 200, mit `access-control-allow-origin: *`, demselben
     Baum (response > data > shop > reviews > review) und denselben Feldnamen. Der
     Umbau ist deshalb ein Quellenwechsel, keine Umstrukturierung — `karte()` bleibt
     unveraendert, weil die Objekte hier auf dieselben Felder abgebildet werden.
     Wer spaeter zurueck auf JSON will: erst `curl -o /dev/null -w '%{http_code}'` auf
     die .json-Variante, und zwar mit einer FREMDEN Shop-ID gegengeprobt. */
  function feld(knoten, name) {
    var e = knoten.getElementsByTagName(name)[0];
    return e ? (e.textContent || '') : '';
  }

  function holenBewertungen(url) {
    return fetch(url, { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (txt) {
        var doc = new DOMParser().parseFromString(txt, 'application/xml');
        if (doc.getElementsByTagName('parsererror').length) throw new Error('XML unlesbar');
        var knoten = doc.getElementsByTagName('review');
        var aus = [];
        for (var i = 0; i < knoten.length; i++) {
          aus.push({
            comment: feld(knoten[i], 'comment'),
            mark: feld(knoten[i], 'mark'),
            creationDate: feld(knoten[i], 'creationDate'),
            UID: feld(knoten[i], 'UID')
          });
        }
        return aus;
      });
  }

  /* — Kennzahlen links — */
  function kennzahlen(wurzel) {
    var kanal = wurzel.getAttribute('data-kanal');
    if (!kanal) return;
    holen(GRADES + kanal + '/touchpoints/all/feed.json')
      .then(function (d) {
        var g = d && d.grades && d.grades.overall;
        if (!g || typeof g.count !== 'number') return;

        var anz = wurzel.querySelector('[data-ao-tsrev-anzahl]');
        if (anz) anz.textContent = zahl(g.count);

        var v = g.distribution;
        if (!v || typeof v.fiveStars !== 'number' || !g.count) return;
        // Abgerundet, nie aufgerundet: Eine Werbeaussage soll im Zweifel zu niedrig
        // stehen, nicht zu hoch.
        var pct = Math.floor((v.fiveStars / g.count) * 100);
        var pz = wurzel.querySelector('[data-ao-tsrev-anteil]');
        if (pz) pz.textContent = pct + ' %';
        var balken = wurzel.querySelector('[data-ao-tsrev-balken]');
        if (balken) balken.style.width = pct + '%';
        var zeile = wurzel.querySelector('[data-ao-tsrev-verteilung]');
        if (zeile) zeile.hidden = false;
      })
      .catch(function () { /* still: die Zeilen bleiben einfach verborgen */ });
  }

  /* — Bewertungsliste rechts — */
  // Sterne, nicht die Beeren-Punkte der Produktkarten: Das hier ist fremder Inhalt in
  // fremder Bildsprache — Jonas, 30.08.: „mehr so dargestellt wie von trusted shops
  // vorgegeben". Auf den Produktkarten bleiben die Punkte.
  function sterne(note) {
    var wrap = document.createElement('span');
    wrap.className = 'ao-tsrev__sterne';
    var sterneTmpl = (window.AO_I18N && window.AO_I18N['ao.ts_reviews.stars_label']) || '{{note}} von 5 Sternen';
    wrap.setAttribute('aria-label', sterneTmpl.replace('{{note}}', note.toLocaleString('de-DE')));
    for (var i = 1; i <= 5; i++) {
      var s = document.createElement('span');
      s.className = 'ao-tsrev__stern' + (note >= i ? ' is-full' : '');
      s.setAttribute('aria-hidden', 'true');
      s.textContent = '\u2605';
      wrap.appendChild(s);
    }
    return wrap;
  }

  /* Direktlink auf die einzelne Bewertung im Trusted-Shops-Profil.
     Die offene API liefert die Kennung ohne Bindestriche (32 Hex-Zeichen), der Anker auf
     der Profilseite braucht sie als UUID mit Bindestrichen und dem Präfix `rev-`:
       API   aa8366e019e24b78a90335fc59d74619
       Anker #review-rev-aa8366e0-19e2-4b78-a903-35fc59d74619
     Am 30.08. gegen das Profil-HTML gegengeprüft — der rekonstruierte Anker kommt dort
     tatsächlich vor. Passt die Kennung nicht ins Muster, entfällt der Link. */
  function tiefenlink(profil, uid) {
    if (!profil || !uid) return '';
    var h = String(uid).replace(/-/g, '').toLowerCase();
    if (!/^[0-9a-f]{32}$/.test(h)) return '';
    var uuid = h.slice(0, 8) + '-' + h.slice(8, 12) + '-' + h.slice(12, 16) + '-' +
               h.slice(16, 20) + '-' + h.slice(20);
    return profil.split('#')[0] + '#review-rev-' + uuid;
  }

  function karte(r, profil) {
    var el = document.createElement('article');
    el.className = 'ao-tsrev__stimme';

    // Das Anführungszeichen führt auch das eTrusted-Widget über seinem Zitat.
    var q = document.createElement('span');
    q.className = 'ao-tsrev__anfuehrung';
    q.setAttribute('aria-hidden', 'true');
    q.textContent = '\u201C';
    el.appendChild(q);

    el.appendChild(sterne(parseFloat(r.mark) || 0));

    var p = document.createElement('p');
    p.className = 'ao-tsrev__zitat';
    // textContent, nicht innerHTML: Der Text ist Fremdinhalt aus einer offenen
    // Schnittstelle und wird nie als Markup interpretiert.
    p.textContent = r.comment;
    el.appendChild(p);

    var meta = document.createElement('p');
    meta.className = 'ao-tsrev__meta';
    var d = new Date(r.creationDate);
    // Kurzes Datum und kurzer Prüfvermerk: „28. August 2026 · verifizierte Bewertung"
    // brach in der 250px schmalen Karte auf zwei Zeilen um.
    var datum = isNaN(d) ? '' : d.toLocaleDateString('de-DE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    // Trusted Shops gibt in dieser Schnittstelle keine Namen heraus (anonymisiert),
    // deshalb steht hier Datum und Prüfvermerk statt eines Namens.
    var verifiziert = (window.AO_I18N && window.AO_I18N['ao.ts_reviews.verified_review']) || 'Verifizierte Bewertung';
    meta.textContent = datum ? datum + ' · ' + verifiziert : verifiziert;
    el.appendChild(meta);

    var ziel = tiefenlink(profil, r.UID);
    if (ziel) {
      var a = document.createElement('a');
      a.className = 'ao-tsrev__stimmelink';
      a.href = ziel;
      a.target = '_blank';
      a.rel = 'noopener nofollow';
      a.textContent = (window.AO_I18N && window.AO_I18N['ao.ts_reviews.view_on_trusted_shops']) || 'Bei Trusted Shops ansehen';
      var hint = document.createElement('span');
      hint.className = 'visually-hidden';
      hint.textContent = (window.AO_I18N && window.AO_I18N['ao.ts_reviews.opens_new_tab']) || ' (öffnet in neuem Tab)';
      a.appendChild(hint);
      el.appendChild(a);
    }

    return el;
  }

  function stimmen(wurzel) {
    var liste = wurzel.querySelector('[data-ao-tsrev-liste]');
    if (!liste) return;
    var tsid = wurzel.getAttribute('data-tsid');
    var profil = wurzel.getAttribute('data-profil') || '';
    var max = parseInt(wurzel.getAttribute('data-anzahl'), 10) || 3;
    if (!tsid) { einspaltig(wurzel); return; }

    holenBewertungen(REVIEWS + tsid + '/reviews.xml')
      .then(function (alle) {
        var mitText = alle.filter(function (x) { return x.comment && x.comment.trim(); });
        if (!mitText.length) { einspaltig(wurzel); return; }
        var frag = document.createDocumentFragment();
        mitText.slice(0, max).forEach(function (x) { frag.appendChild(karte(x, profil)); });
        liste.textContent = '';
        liste.appendChild(frag);
        liste.setAttribute('data-ao-tsrev-geladen', 'true');
      })
      .catch(function () { einspaltig(wurzel); });
  }

  function einspaltig(wurzel) {
    var grid = wurzel.querySelector('.ao-tsrev__grid');
    var rechts = wurzel.querySelector('.ao-tsrev__stimmen');
    if (grid) grid.classList.add('ao-tsrev__grid--solo');
    if (rechts) rechts.hidden = true;
  }

  function start() {
    var alle = document.querySelectorAll('[data-ao-tsrev]:not([data-ao-tsrev-gestartet])');
    for (var i = 0; i < alle.length; i++) {
      alle[i].setAttribute('data-ao-tsrev-gestartet', 'true');
      kennzahlen(alle[i]);
      stimmen(alle[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // Der Theme-Editor baut Sektionen neu auf, ohne die Seite zu laden.
  document.addEventListener('shopify:section:load', start);
})();
